module.exports = __webpack_public_path__ + "img/랜딩페이지_3x.2a1d42c5.jpg";